<!-- //
组件-边框
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="widgetProps" :has-datasource-tab="false">
  </PropsWrapper>
</template>

<script>

export default {
  name: 'WidgetBorderForm',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style lang="less" scoped>
</style>
